import { render, staticRenderFns } from "./CategoryContent.vue?vue&type=template&id=33f59fdd"
import script from "./CategoryContent.vue?vue&type=script&lang=js"
export * from "./CategoryContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports